import { api, formatPattern, METHOD, REQUEST_URL } from '../../utils';

export const mergeDevices = (oldDeviceId, newDeviceId) =>  (
    api(formatPattern(
        REQUEST_URL.DEVICE_MERGE, {oldDeviceId, newDeviceId}
    ), METHOD.PATCH).catch(err => {throw err})
)
